// extracted by mini-css-extract-plugin
export var above250Subtext = "planCard-module--above250Subtext--eb8d8";
export var amount = "planCard-module--amount--3d5f3";
export var below250Card = "planCard-module--below250Card--55da9";
export var button = "planCard-module--button--fcee2";
export var buttonContainer = "planCard-module--buttonContainer--a13e7";
export var buttons = "planCard-module--buttons--c96d7";
export var cardContents = "planCard-module--cardContents--ac0a8";
export var collapsible = "planCard-module--collapsible--17522";
export var collapsibleContainer = "planCard-module--collapsibleContainer--38592";
export var contactButton = "planCard-module--contactButton--6d2b0";
export var description = "planCard-module--description--d7bdd";
export var divider = "planCard-module--divider--1122b";
export var emailSendsContainer = "planCard-module--emailSendsContainer--db833";
export var emailSendsPlusContainer = "planCard-module--emailSendsPlusContainer--75be1";
export var emailSendsText = "planCard-module--emailSendsText--55c55";
export var featuresListContainer = "planCard-module--featuresListContainer--63477";
export var freeAmount = "planCard-module--freeAmount--ccb19";
export var freeCardEmailSends = "planCard-module--freeCardEmailSends--d1271";
export var freeCardEyebrow = "planCard-module--freeCardEyebrow--f7fa8";
export var freeCardPlanNameContainer = "planCard-module--freeCardPlanNameContainer--c79c2";
export var freeCardStats = "planCard-module--freeCardStats--a8d2b";
export var freeCardStatsContainer = "planCard-module--freeCardStatsContainer--6ac3c";
export var freeText = "planCard-module--freeText--a814a";
export var iconDown = "planCard-module--iconDown--7e683";
export var iconUp = "planCard-module--iconUp--3f05a";
export var planCard = "planCard-module--planCard--2400c";
export var planName = "planCard-module--planName--60bb1";
export var planNameContainer = "planCard-module--planNameContainer--f8001";
export var priceEyebrow = "planCard-module--priceEyebrow--232bf";
export var priceWrapper = "planCard-module--priceWrapper--80f63";
export var recommended = "planCard-module--recommended--3256a";
export var recommendedText = "planCard-module--recommendedText--d28b6";
export var smsSubText = "planCard-module--smsSubText--30b10";
export var start = "planCard-module--start--d4bbf";
export var statsContainer = "planCard-module--statsContainer--523a8";
export var text = "planCard-module--text--fee5c";
export var timePeriod = "planCard-module--timePeriod--553e5";